<template>
    <div class="row mb-1 mx-3 d-flex justify-content-end">
        <div class="error-container" ref="errorContainer" role="alert" aria-live="assertive" v-if="error_message !== ''">
            <button type="button" class="close-btn" aria-label="Dismiss error message" @click="clear_message">X</button>
            <div>
                <img :src="require('@/assets/images/wolverine.svg')" width="100" height="100" alt="" aria-hidden="true" />
            </div>
            <div class="error-info">
                <p class="error-title">Error</p>
                <p class="timestamp">{{ errorTimestamp }}</p>
                <p class="subtitle">
                    <span class="typing">{{ typedMessage }}</span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { useSessionStore } from '@/stores/SessionStore'
import { defineComponent, onMounted, ref } from 'vue';

export default defineComponent({
    name: 'error-toast',
    props: {
        error_index: {
            type: Number,
            required: true
        },
        error_message: {
            type: String,
            default: 'An error has occurred in the python syntax. Please refresh the page or contact SDSI.'
        }
    },
    setup(props) {
        let errorTimestamp = Date.now()
        errorTimestamp = new Date(errorTimestamp).toLocaleString('en-US', { timeZone: 'America/Denver' })
        const sessionStore = useSessionStore()
        const typedMessage = ref('')

        onMounted(() => {
            typeMessage(props.error_message);
        })

        function typeMessage(message) {
            if (message === '') return;

            let i = 0;
            typedMessage.value = '';
            const typing = setInterval(() => {
                if (i < message.length) {
                    typedMessage.value += message.charAt(i);
                    i++;
                } else {
                    clearInterval(typing);
                }
            }, 10); // adjust the speed of typing here
        }

        function clear_message() {
            sessionStore.error_messages.splice(props.error_index, 1);
        }

        return { sessionStore, typedMessage, errorTimestamp, typeMessage, clear_message }
    },
});
</script>

<style scoped>
    .error-container {
        position: relative;
        background-color: rgba(0, 0, 0, 0.8);
        display: flex;
        align-items: center;
        border-radius: 10px;
        outline: 1px solid white;
        width: min(95vw, 500px);
    }
    @media (min-width: 600px) {
        .error-container {
            padding: 10px;
        }
    }
    .subtitle {
        color: #00ff00;
        font-family: 'Roboto Mono', monospace;
    }

    .error-info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
    }

    .error-title {
        color: #00ff00;
        font-family: 'Roboto', sans-serif;
        font-size: 1.5em;
        font-weight: bold;
        margin: 0;
    }

    .typing {
        white-space: pre-wrap;
        overflow: pre-wrap;
    }

    .close-btn {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
        color: white;
        background: none;
        border: none;
        padding: 0;
        line-height: 1;
    }
    .timestamp {
        color: #00b300;
        font-family: 'Roboto Mono', monospace;
        font-size: 0.8em;
        font-style: italic;
    }
</style>
